
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSleetShowersPolartwilight as ObiSleetShowersPolartwilightElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-sleet-showers-polartwilight.js';
 
 
 

 
 export const ObiSleetShowersPolartwilight = createComponent({
   react: React,
   tagName: 'obi-sleet-showers-polartwilight',
   elementClass: ObiSleetShowersPolartwilightElement,
   events: {
     
   }
  });
 
 